import type { Fallacy } from "./types";
import { createStory } from "./types";

export const movingGoalposts: Fallacy = {
    id: "moving-goalposts",
    name: "Moving the Goalposts",
    emoji: "🥅",
    category: "Jebakan Bahasa",
    description:
      "Terus **mengubah syarat** pembuktian setelah syarat sebelumnya terpenuhi, sehingga lawan bicara **tidak pernah bisa menang**.",
    tldr: "Udah memenuhi syarat? Syaratnya diubah lagi. Gak ada habisnya.",
    detail:
      "Moving the Goalposts adalah taktik di mana seseorang **terus mengubah kriteria pembuktian** begitu lawannya berhasil memenuhi syarat sebelumnya. Seperti bermain sepak bola di mana setiap kali kamu hampir mencetak gol, **gawangnya dipindahkan**.\n\nPola umumnya:\n1. A meminta bukti X → B memberikan bukti X\n2. A bilang kurang, minta bukti Y → B memberikan Y\n3. A bilang Y juga kurang, minta Z\n4. **Siklus ini terus berulang tanpa akhir**\n\nCara melawan: Minta lawan bicara **menetapkan semua kriteria di awal** sebelum kamu memberikan bukti. Dokumentasikan syarat-syarat yang sudah disepakati agar tidak bisa digeser.",
    story: createStory("Moving the Goalposts", "🥅", {
      hook: {
        title: "Kamu udah memenuhi semua syarat.",
        body: "Tapi tiba-tiba syaratnya ditambah lagi. Dan lagi. Dan lagi. Gak ada habisnya.",
      },
      convo: {
        claim: "Aku udah dapet sertifikasi yang kamu minta buat naik jabatan. Udah selesai semua syaratnya. Eh sekarang diminta **pimpin tim dulu minimal 2 tahun** — padahal itu gak pernah disebut sebelumnya.",
        response: "Syarat lama terpenuhi, syarat baru muncul. **Gawangnya dipindahin.**",
      },
      reveal: {
        body: "Setiap kali kamu hampir \"gol\", **gawangnya dipindahin**. Kriterianya terus diubah biar kamu **gak pernah bisa menang**.",
      },
      insight: {
        title: "Polanya selalu sama:",
        body: "Kamu kasih bukti A, diminta B. Kasih B, diminta C. **Gak ada titik \"cukup\"** — karena tujuannya memang biar kamu gak pernah menang.",
      },
      engagement: {
        title: "Siapa yang paling sering geser gawang ke kamu?",
        body: "Bos di kantor atau pasangan? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["red-herring", "cherry-picking", "straw-man"],
  };
